(function () {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const marquees = document.querySelectorAll('.js-marquee');

    marquees.forEach((marquee) => {
        const viewport = marquee.querySelector('.marquee__viewport');
        const content = marquee.querySelector('.marquee__content');
        if (!viewport || !content) return;

        const direction = (marquee.dataset.direction || 'left').toLowerCase();
        const speed = Number(marquee.dataset.speed || 40); // px/sec

        let rafId = null;
        let lastTs = 0;
        let x = 0;
        let cycleWidth = 0;

        // Clone enough times so we never see blank space.
        // We want content width >= viewport * 2 for safety.
        function rebuild() {
            // Reset to original items (first set only)
            const originals = Array.from(content.children).filter((el) => !el.dataset.clone);
            content.innerHTML = '';
            originals.forEach((el) => content.appendChild(el));

            // Measure one full "set"
            const set = document.createElement('div');
            set.style.display = 'flex';
            set.style.alignItems = 'center';
            set.style.width = 'max-content';
            originals.forEach((el) => set.appendChild(el.cloneNode(true)));
            // Not using this detached set visually; we measure via real DOM below.

            // Build at least 2 sets, then keep cloning until wide enough
            const makeCloneSet = () => {
                const frag = document.createDocumentFragment();
                originals.forEach((node) => {
                    const clone = node.cloneNode(true);
                    clone.dataset.clone = '1';
                    // remove alt text for clones (avoid repeated SR announcements)
                    const img = clone.querySelector('img');
                    if (img) img.alt = '';
                    frag.appendChild(clone);
                });
                return frag;
            };

            // Add one clone set to enable looping
            content.appendChild(makeCloneSet());

            // Now measure cycle width = width of originals set (not including clones)
            // We can compute it by measuring first N items (originals.length)
            const allItems = Array.from(content.children);
            const firstSetItems = allItems.slice(0, originals.length);

            const firstSetWidth = firstSetItems.reduce((acc, el) => acc + el.getBoundingClientRect().width, 0);
            cycleWidth = Math.max(1, firstSetWidth);

            // Ensure total width is >= viewport * 2
            const viewportWidth = viewport.getBoundingClientRect().width;
            while (content.getBoundingClientRect().width < viewportWidth * 2) {
                content.appendChild(makeCloneSet());
            }

            // Reset position safely
            x = 0;
            applyTransform();
        }

        function applyTransform() {
            content.style.transform = `translate3d(${x}px,0,0)`;
        }

        function tick(ts) {
            if (!lastTs) lastTs = ts;
            const dt = (ts - lastTs) / 1000;
            lastTs = ts;

            const dir = direction === 'right' ? 1 : -1;
            x += dir * speed * dt;

            // Wrap seamlessly based on cycle width
            if (dir === -1 && x <= -cycleWidth) x += cycleWidth;
            if (dir === 1 && x >= 0) x -= cycleWidth;

            applyTransform();
            rafId = requestAnimationFrame(tick);
        }

        // Wait for images/fonts to settle, then build
        const start = () => {
            cancelAnimationFrame(rafId);
            rafId = null;
            lastTs = 0;
            rebuild();
            rafId = requestAnimationFrame(tick);
        };

        // Start when images load (important for correct measurement)
        const imgs = Array.from(content.querySelectorAll('img'));
        let pending = imgs.length;

        if (!pending) {
            start();
        } else {
            imgs.forEach((img) => {
                if (img.complete) {
                    pending -= 1;
                    if (pending === 0) start();
                } else {
                    img.addEventListener(
                        'load',
                        () => {
                            pending -= 1;
                            if (pending === 0) start();
                        },
                        { once: true },
                    );
                    img.addEventListener(
                        'error',
                        () => {
                            pending -= 1;
                            if (pending === 0) start();
                        },
                        { once: true },
                    );
                }
            });
        }

        // Rebuild on resize (debounced)
        let resizeT = null;
        window.addEventListener('resize', () => {
            clearTimeout(resizeT);
            resizeT = setTimeout(start, 150);
        });
    });
})();